import { render, staticRenderFns } from "./Institutions.vue?vue&type=template&id=ef6691c2&scoped=true"
import script from "./Institutions.vue?vue&type=script&lang=js"
export * from "./Institutions.vue?vue&type=script&lang=js"
import style0 from "./Institutions.vue?vue&type=style&index=0&id=ef6691c2&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6691c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef6691c2')) {
      api.createRecord('ef6691c2', component.options)
    } else {
      api.reload('ef6691c2', component.options)
    }
    module.hot.accept("./Institutions.vue?vue&type=template&id=ef6691c2&scoped=true", function () {
      api.rerender('ef6691c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/institutions/Institutions.vue"
export default component.exports